package team.platforma.dictionary_domain.model

data class AiModelDomain(
   val id : Long,
   val name : String,
   val chapter : Long,
   val description : String,
   val cover : String?
)
